<script>
  import { onMount } from 'svelte';

  export let delay = 0;
  export let distance = 24;
  export let once = true;

  let el;
  let visible = false;

  onMount(() => {
    if (typeof IntersectionObserver === 'undefined') {
      visible = true;
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            visible = true;
            if (once) observer.disconnect();
          } else if (!once) {
            visible = false;
          }
        }
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
    );
    if (el) observer.observe(el);
    return () => observer.disconnect();
  });
</script>

<div
  bind:this={el}
  class="reveal"
  class:visible
  style={`--reveal-delay: ${delay}ms; --reveal-distance: ${distance}px;`}
>
  <slot />
</div>

<style>
  .reveal {
    opacity: 0;
    transform: translateY(var(--reveal-distance));
    transition:
      opacity 600ms cubic-bezier(0.22, 0.61, 0.36, 1) var(--reveal-delay),
      transform 600ms cubic-bezier(0.22, 0.61, 0.36, 1) var(--reveal-delay);
    will-change: opacity, transform;
  }

  .reveal.visible {
    opacity: 1;
    transform: translateY(0);
  }

  @media (prefers-reduced-motion: reduce) {
    .reveal,
    .reveal.visible {
      opacity: 1;
      transform: none;
      transition: none;
    }
  }
</style>
